import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent } from 'src/app/component/footer/footer.component';
import { ProfileComponent } from 'src/app/component/profile/profile.component';
import { Signup4PaymentComponent } from 'src/app/component/signup4-payment/signup4-payment.component';
import { ProfileDropdownComponent } from 'src/app/profileComponent/profile-dropdown.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { ToastrModule } from 'ngx-toastr';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from '../../dialog/info-dialog/info-dialog.component';

@NgModule({
  declarations: [FooterComponent, ProfileComponent, Signup4PaymentComponent, ConfirmDialogComponent, InfoDialogComponent, ProfileDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    NgxTypedJsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
    }),
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [
    FooterComponent,
    ProfileComponent,
    Signup4PaymentComponent,
    TranslateModule,
    NgbModule,
    NgxTypedJsModule,
    ToastrModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    ConfirmDialogComponent,
    MatDialogModule,
    InfoDialogComponent,
    ProfileDropdownComponent
  ],
})
export class SharedModuleModule { }
